export enum EZarucenieEmise {
    ST = 'ST',
    JS = 'JS',
    HZL = 'HZL',
    BEZ = 'BEZ',
    VZ = 'VZ',
    SZ = 'SZ',
    ZA = 'ZA',
    NE = 'NE',
    NZ = 'NZ',
    SE = 'SE',
    SP = 'SP',
    JU = 'JU',
    JP = 'JP',
    NA = 'NA'
}
